import React from 'react';
import PropTypes from 'prop-types';
// Helpers
import { formatRating } from '../../helpers';
// Styles
import { Wrapper } from './RatingRing.styles';

const R = 26;
const CIRC = 2 * Math.PI * R;

export const ratingColor = rating => {
  if (!rating) return 'var(--muted)';
  if (rating >= 7.5) return '#3fae6a';
  if (rating >= 6) return 'var(--gold)';
  return 'var(--accent)';
};

const RatingRing = ({ rating, votes }) => {
  const pct = Math.max(0, Math.min(1, (rating || 0) / 10));
  return (
    <Wrapper>
      <svg viewBox='0 0 64 64' aria-hidden='true'>
        <circle cx='32' cy='32' r={R} className='track' />
        <circle
          cx='32'
          cy='32'
          r={R}
          className='value'
          style={{
            stroke: ratingColor(rating),
            strokeDasharray: CIRC,
            strokeDashoffset: CIRC * (1 - pct)
          }}
        />
      </svg>
      <div className='score'>
        <strong>{formatRating(rating)}</strong>
      </div>
      <div className='label'>
        <span>TMDB score</span>
        {votes ? <small>{votes.toLocaleString('en-US')} votes</small> : null}
      </div>
    </Wrapper>
  );
};

RatingRing.propTypes = {
  rating: PropTypes.number,
  votes: PropTypes.number
};

export default RatingRing;
